
import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

@Component({
  components: {},
})
export default class Emails extends Vue {
  public fields = [
    {
      key: 'Email',
      label: 'Email',
      sortable: true,
    },
  ];

  public emails: any[] = [];
  public validEmails: any[] = [];
  public invalidEmails: any[] = [];
  public duplicateEmails: any[] = [];
  public isBusy = false;
  public filter = '';

  public mounted() {
    this.loadEmails();
  }

  public loadEmails() {
    this.isBusy = true;
    axios.get('/api/v4/EMail/').then(
      (response: any) => {
        const d = response.data.notifyOfNewIssues || [];
        this.isBusy = false;
        this.emails = d;
      },
      (error) => {
        this.isBusy = false;
      }
    );
  }

  public saveEmails() {
    this.isBusy = true;
    if (this.invalidEmails.length > 0) {
      this.makeToast('There are invalid emails in the list', 'danger');
      return;
    }

    const b = [
      { op: 'replace', path: '/notifyOfNewIssues', value: this.emails },
    ];
    axios.patch('/api/v4/EMail', b).then(
      (response: any) => {
        this.loadEmails();
        this.makeToast('Emails Saved');
      },
      (error) => {
        this.isBusy = false;
        this.makeToast(
          'There was a problem saving the emails, please try again later.',
          'danger'
        );
      }
    );
  }

  public onTagState(valid, invalid, duplicate) {
    this.validEmails = valid;
    this.invalidEmails = invalid;
    this.duplicateEmails = duplicate;
  }

  public isEmailValid(str: string) {
    const reg = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    return str.match(reg);
  }

  public tagValidator(tag) {
    const t = tag.toLowerCase();
    return this.isEmailValid(t);
  }

  public makeToast(msg, vrant = 'success') {
    this.$bvToast.toast(`${msg}`, {
      title: 'Operation Completed',
      autoHideDelay: 3000,
      variant: vrant,
      appendToast: false,
    });
  }
}
